// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除
// 不再维护该组件,请转移至emop-table-pro中使用,该组件不要删除


import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EmopFormItemDataType } from '../../common/EmopFormItemDataType';
import { EmopTableInfoType } from '../../common/EmopTableInfoType';

@Component({
  selector: 'emop-table',
  templateUrl: './emop-table.component.html',
  styleUrls: ['./emop-table.component.scss']
})
export class EmopTableComponent implements OnInit {
  // table内置的属性
  indeterminate: boolean;
  allChecked: boolean = false;

  // 筛选数据
  filterData = {
    visible: false,
    searchValue: '',
    key: null
  };
  // 编辑单元格数据
  editCellData = {
    key: null,
    index: null
  };
  // 编辑表单数据
  editFormData: EmopFormItemDataType = {
    type: null,
    value: null,
    key: 'TABLE_TEMP_INPUT',
  };
  // 模板tableInfo
  tempTableInfo: EmopTableInfoType;
  @Input() tableInfo: EmopTableInfoType;
  @Input() scroll = null;
  @Input() paginationSize: 'small' | 'default' = 'default';
  @Output() pageIndexChange = new EventEmitter();
  @Output() pageSizeChange = new EventEmitter();
  constructor(
  ) { }

  ngOnChanges({ tableInfo }): void {
    if (tableInfo) {
      if (!tableInfo) return;
      tableInfo = tableInfo.currentValue;
      tableInfo.header.forEach(item => {
        // 默认为true的数据
        ['enable', 'visible'].forEach(attribute => {
          item[attribute] = item[attribute] === undefined ? true : item[attribute];
        });
        if (item.sortFn === true) {
          item.sortFn = {
            fn: (a, b) => {
              return a[item.key].localeCompare(b[item.key]);
            },
            default: null,
            directions: [null, 'ascend', 'descend']
          };
        }
        // 设置默认width
        this.tableInfo.header.forEach(item => {
          if (!item.width) item.width = (100 / this.tableInfo.header.length).toFixed(2) + '%';
        });
      });
      ['showPagination', 'frontPagination'].forEach(item => {
        tableInfo[item] = tableInfo[item] === undefined ? true : tableInfo[item];
      });
      this.cloneData();
    }
  }

  ngOnInit(): void {
    if (!this.tableInfo) return console.error('请传入tableInfo');
    // pageInfo属性
    if (!this.tableInfo.pageInfo) {
      this.tableInfo.pageInfo = {
        pageSize: 10,
        pageIndex: 1,
        totalCount: null
      };
    }
    if (!this.tableInfo.checkboxSelected) {
      this.tableInfo.checkboxSelected = [];
    }
    if (!this.tableInfo.radioSelected) {
      this.tableInfo.radioSelected = null;
    }
  }
  reset(key: string): void {
    this.filterData.searchValue = '';
    this.search(key);
  }
  /**
   * 筛选的搜索功能
   * @param key 搜索的关键字
   * @param e 事件
   * @returns 
   */
  search(key: string, e?): void {
    if (e && e.key !== 'Enter') {
      return;
    }
    this.filterData.visible = false;
    this.tableInfo.data = this.tempTableInfo.data.filter(item => {
      return item[key].indexOf(this.filterData.searchValue) !== -1;
    });
  }
  /**
   * 开始编辑单元格的回调函数
   * @param key tableInfo.header[].key
   * @param index 索引值
   */
  startEdit(key: string, index: number) {
    this.editFormData.value = this.tableInfo.data[index][key];
    this.editFormData.options = this.tableInfo.header.find(item => item.key === key).editFn.options || [];
    this.editFormData.type = this.tableInfo.header.find(item => item.key === key).editFn.type || 'str';
    this.editCellData.key = key;
    this.editCellData.index = index;
  }
  /**
   * 停止编辑单元格的回调函数
   * @param key tableInfo.header[].key
   * @param index 索引值
   */
  editCellSubmit(key: string, index: number) {
    this.tableInfo.data[index][key] = this.editFormData.value;
    this.cloneData();
    this.editCellCancel();
    const target = this.tableInfo.header.find(item => item.key === key);
    target.editFn?.fn && target.editFn.fn(this.tableInfo.data[index], key);
  }
  editCellCancel() {
    this.editCellData.key = null;
    this.editCellData.index = null;
  }
  /**
   * 点击全选
   * @param $event 选中值
   */
  onAllChecked($event) {
    this.initCheckedAttribute();
    this.tableInfo.checkboxSelected = [];
    if ($event) {
      if (this.tableInfo.selectedTag) {
        for (let i = 0; i < this.tableInfo.data.length; i++) {
          if (this.tableInfo.selectedTag === 'index') {
            this.tableInfo.checkboxSelected.push(i);
          } else {
            this.tableInfo.checkboxSelected.push(this.tableInfo.data[i][this.tableInfo.selectedTag]);
          }
        }
      } else {
        this.tableInfo.checkboxSelected = this.tableInfo.data;
      }
    }
  }
  /**
   * 初始化checked属性
   */
  initCheckedAttribute() {
    if (!this.tableInfo.checkboxSelected) this.tableInfo.checkboxSelected = [];
  }
  /**
   * 选中单个多选框或多选框
   * @param index 索引
   * @param $event 选中值
   */
  onItemChecked(index, $event) {
    this.initCheckedAttribute();
    // 多选框
    if (this.tableInfo.type === 'checkbox') {
      if ($event) {
        if (this.tableInfo.selectedTag) {
          if (this.tableInfo.selectedTag === 'index') {
            this.tableInfo.checkboxSelected.push(index);
          } else {
            this.tableInfo.checkboxSelected.push(this.tableInfo.data[index][this.tableInfo.selectedTag]);
          }
        } else {
          this.tableInfo.checkboxSelected.push(this.tableInfo.data[index]);
        }
      } else {
        if (this.tableInfo.selectedTag) {
          if (this.tableInfo.selectedTag === 'index') {
            this.tableInfo.checkboxSelected = this.tableInfo.checkboxSelected.filter(item => item !== index);
          } else {
            this.tableInfo.checkboxSelected = this.tableInfo.checkboxSelected.filter(item => item !== this.tableInfo.data[index][this.tableInfo.selectedTag]);
          }
        } else {
          this.tableInfo.checkboxSelected = this.tableInfo.checkboxSelected.filter(item => item !== this.tableInfo.data[index]);
        }
      }
      this.cloneData();
    }
  }
  /**
   * 深拷贝数据
   */
  cloneData() {
    this.tempTableInfo = JSON.parse(JSON.stringify(this.tableInfo || []));
  }
  /**
   * 页码切换的回调
   * @param index 索引值
   */
  pageIndexChangeFn(index: number) {
    this.pageIndexChange.emit(index);
  }
  pageSizeChangeFn(size: number) {
    this.pageSizeChange.emit(size);
  }
  /**
   * 从当前的索引值获取数据中真实的索引值(翻页时传入的index并不是真实的索引值)
   */
  getRealIndex(index) {
    if (this.tableInfo.frontPagination) {
      return (this.tableInfo.pageInfo.pageIndex - 1) * this.tableInfo.pageInfo.pageSize + index;
    } else {
      return index;
    }
  }
  /**
   * 操作按钮的回调函数
   * @param key header的唯一标识符
   * @param action 点击的行为
   * @param data 整行的数据
   * @param index 索引
   */
  actionFn(key, action, data, index) {
    // 小图标模式时
    if (action.indexOf('icon-') !== -1) action = this.tableInfo.header.find(item => item.key === key)?.action.find(item => item.icon === action).alias;
    const target = this.tableInfo.header.find(item => item.key === key)?.action.find(item => item.key === action);
    if (target) {
      target.fn(data, index);
    } else {
      console.error(`请检查传入的tableInfo里header属性中是否存在"${action}"的action`);
    }
  }
  /**
   * LOV待翻译的文本
   * @param val 待翻译的英文值
   * @param options 字典翻译(options对象)
   * @returns string 中文值
   */
  lovGetKey(val, options): string {
    if (val === 'test1') {
      console.log(val, options);
    }
    // 当不存在选项时,直接返回
    if (!options?.length) return val;
    const target = options.find(item => item.val == val);
    if (target) {
      return target && target.key;
    }
  }
  /**
   * 根据key获取指定action
   * @param key header的key值
   * @param action action字符串
   */
  getActionByKey(key: string, action: string) {
    const target = this.tableInfo.header.find(item => item.key === key);
    if (target) {
      return target.action.find(item => item.key === action);
    }
  }
}
